function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.352 1.943a1.705 1.705 0 100 3.41 1.705 1.705 0 000-3.41zM9.705 3.648a2.648 2.648 0 11.528 1.587L6.189 7.256a2.648 2.648 0 010 1.488l4.044 2.021a2.648 2.648 0 11-.422.843L5.767 9.588a2.648 2.648 0 110-3.174l4.044-2.022a2.649 2.649 0 01-.106-.743zM3.648 6.295a1.705 1.705 0 100 3.41 1.705 1.705 0 000-3.41zm8.704 4.353a1.705 1.705 0 100 3.41 1.705 1.705 0 000-3.41z",
  fill: "#2D2D2D"
});
function SvgCompartir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Compartir.svg";
export { SvgCompartir as ReactComponent };